import { render } from "./CalcTaxRecord.vue?vue&type=template&id=b5c4be6e&scoped=true"
import script from "./CalcTaxRecord.vue?vue&type=script&lang=js"
export * from "./CalcTaxRecord.vue?vue&type=script&lang=js"

import "./CalcTaxRecord.vue?vue&type=style&index=0&id=b5c4be6e&lang=less&scoped=true"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c4be6e"]])

export default __exports__